var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.account && _vm.customer)?_c('account-form',{attrs:{"account":_vm.account,"loading":_vm.loading,"mode":_vm.mode,"customer":_vm.customer},on:{"submit":_vm.onSubmit}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }